import PortalQuoteQueryJets from "../../components/portal/PortalQuoteQueryJets"

const PortalHome = ({}) => {

    const modalComplete = () => {

    }

    return (
        <>
            <section className='home__query'>
                <div className='home__query__content wrap'>
                    <h1 className='portal__title'>Welcome Aboard</h1>

                    <PortalQuoteQueryJets 
                        onModalSuccess={modalComplete}
                    />
                </div>
            </section>
        </>
    )


}


export default PortalHome